/*
 * localStorage 本地存储  是否应该加密？，加个开启加密的开关
 */
const prefix = "yhz_";
const storage = {
  // 本地存储前缀
  prefix: prefix,
  /*
   *@method 写入存储
   *@param  String name 保存本地的key
   *@param  mix    value 混合类型
   *@return
   */
  set(name, value) {
    const keys = this.prefix + name;
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    return localStorage.setItem(keys, value);
  },
  /*
   *@method 获取本地存储
   *@param  String name 保存本地的key
   *@return
   */
  get(name) {
    const keys = this.prefix + name;
    let value = localStorage.getItem(keys);
    if (/^(\{.*\})|(\[.*\])$/.test(value)) value = JSON.parse(value);
    return value;
  },
  /*
   *@method 移除本地存储
   *@param  String name 保存本地的key
   *@return
   */
  remove(name) {
    const keys = this.prefix + name;
    return localStorage.removeItem(keys);
  },
  /*
   *@method 移除全部本地存储
   *@param  String name 保存本地的key
   *@return
   */
  clear() {
    localStorage.clear();
  }
};

export {
  storage
}
